import { ref } from "vue";

const metrics_output = ref({});

export {
    metrics_output
}